/**
 * Footer wave animation — self-contained, independent from other sections.
 * Reads [data-footer-wave] on <footer> and morphs 3 SVG wave paths
 * plus an optional top-edge wave divider.
 */
(function () {
  const footer = document.querySelector(".wt-footer[data-footer-wave]");
  if (!footer) return;

  const paths = footer.querySelectorAll(".wt-footer__wave path");
  const topPath = footer.querySelector(".wt-footer__wave-top path");

  if (!paths.length && !topPath) return;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  /* ── Speed multiplier from setting (1-10, default 5 = 1×) ── */
  const speedSetting = parseFloat(footer.dataset.waveSpeed) || 5;
  const speedMul = speedSetting / 5;

  /* ── Internal wave configs (decorative layers inside footer) ── */
  const configs = [
    { speed: 0.01 * speedMul, amplitude: 7, frequency: 0.007, phase: 0.5 },
    { speed: 0.016 * speedMul, amplitude: 5, frequency: 0.011, phase: 2.5 },
    { speed: 0.02 * speedMul, amplitude: 3.5, frequency: 0.015, phase: 4.5 },
  ];

  /* ── Top-edge wave config (page→footer divider) ── */
  const topConfig = { speed: 0.006 * speedMul, amplitude: 10, frequency: 0.005, phase: 1.0 };

  /* ── Catmull-Rom sample + cubic bezier for smooth waves ── */
  function sampleWavePoints(N, W, phase, layerIndex, amplitude, frequency, yBase) {
    var pts = [];
    for (var i = 0; i <= N; i++) {
      var x = (i / N) * W;
      var t = x * frequency + phase + layerIndex * 1.3;
      pts.push({
        x: x,
        y: yBase + Math.sin(t) * amplitude + Math.sin(t * 0.6 + phase * 0.4) * (amplitude * 0.4) + Math.sin(t * 1.8 + layerIndex) * (amplitude * 0.15)
      });
    }
    return pts;
  }

  function catmullRomPath(pts) {
    var d = "";
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      d += " C" + (p1.x + (p2.x - p0.x) / 6).toFixed(1) + "," + (p1.y + (p2.y - p0.y) / 6).toFixed(1)
         + " " + (p2.x - (p3.x - p1.x) / 6).toFixed(1) + "," + (p2.y - (p3.y - p1.y) / 6).toFixed(1)
         + " " + p2.x.toFixed(1) + "," + p2.y.toFixed(1);
    }
    return d;
  }

  /* ── Internal wave path (fills downward — bottom half) ── */
  function buildWavePath(phase, layerIndex, amplitude, frequency) {
    var W = 1440, H = 40, N = 20;
    var pts = sampleWavePoints(N, W, phase, layerIndex, amplitude, frequency, H * 0.5);
    return "M0," + H + " L" + pts[0].x.toFixed(1) + "," + pts[0].y.toFixed(1) + catmullRomPath(pts) + " L" + W + "," + H + " Z";
  }

  /* ── Top-edge wave path (fills upward — masks footer top with page bg) ── */
  function buildTopWavePath(phase, amplitude, frequency) {
    var W = 1440, H = 60, N = 20;
    var pts = sampleWavePoints(N, W, phase, 0, amplitude, frequency, H * 0.7);
    return "M0,0 L" + pts[0].x.toFixed(1) + "," + pts[0].y.toFixed(1) + catmullRomPath(pts) + " L" + W + ",0 Z";
  }

  /* ── Set initial static paths (also used for reduced-motion) ── */
  paths.forEach(function (p, i) {
    p.setAttribute("d", buildWavePath(configs[i].phase, i, configs[i].amplitude, configs[i].frequency));
  });

  if (topPath) {
    topPath.setAttribute("d", buildTopWavePath(topConfig.phase, topConfig.amplitude, topConfig.frequency));
  }

  if (prefersReduced) return;

  /* ── Animation loop ── */
  var animId;

  function animate() {
    for (var i = 0; i < paths.length; i++) {
      var cfg = configs[i];
      cfg.phase += cfg.speed;
      paths[i].setAttribute(
        "d",
        buildWavePath(cfg.phase, i, cfg.amplitude, cfg.frequency),
      );
    }

    if (topPath) {
      topConfig.phase += topConfig.speed;
      topPath.setAttribute(
        "d",
        buildTopWavePath(topConfig.phase, topConfig.amplitude, topConfig.frequency),
      );
    }

    animId = requestAnimationFrame(animate);
  }

  animId = requestAnimationFrame(animate);

  // Cleanup if Shopify editor removes the section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:unload", function (e) {
      if (e.target.querySelector(".wt-footer[data-footer-wave]")) {
        cancelAnimationFrame(animId);
      }
    });
  }
})();
